const convertHeroData = (isRestricted, props) => {
    const { content: { titleLogged, textLogged, cta, restrictedText, restrictedTitle, restrictedContent }, } = props;
    if (isRestricted && restrictedContent) {
        const convertedCtas = cta
            ? cta
                .filter((item) => item?.additionalBehavior !== "onlyForLoggedIn")
                .map((item) => {
                if (item?.additionalBehavior === "onlyForRestrictedUsers") {
                    return { ...item, additionalBehavior: "onlyForLoggedIn" };
                }
                return item;
            })
            : [];
        return { title: restrictedTitle, text: restrictedText, ctas: convertedCtas };
    }
    return { title: titleLogged, text: textLogged, ctas: cta };
};
export default convertHeroData;
//# sourceMappingURL=convertHeroData.js.map